module.exports = __webpack_public_path__ + "static/media/user-headset.c3a2012b.svg";